
export default {
  name: 'dialog-confirm',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: undefined
    },
    title: {
      type: String,
      default: '注意事項'
    },
    body: {
      type: String,
      default: ''
    },
    minHeight: {
      type: Number,
      default: 240
    }
  },
  computed: {
    opened: function () {
      if (this.visible !== undefined) {
        return this.visible;
      }
      return this.value;
    }
  },
  methods: {
    toastMock: function () {
      if (window.A && A.toast) {
        A.toast('mock：未接线');
      }
    },
    close: function () {
      this.$emit('input', false);
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    onOk: function () {
      this.$emit('ok');
      this.close();
      if (!this.$listeners.ok) {
        this.toastMock();
      }
    },
    onCancel: function () {
      this.$emit('cancel');
      this.close();
      if (!this.$listeners.cancel && !this.$listeners.ok) {
        this.toastMock();
      }
    }
  }
};
